import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ReleaseNotes from '../components/ReleaseNotes';
import HeaderUser from '../components/HeaderUser/HeaderUser';
import MerchantSelector from '../components/MerchantSelector/MerchantSelector';
import useWindowSize from '../utils/resizeHook';
import Hamburger from '../components/Hamburger';
import './Header.scss';
import { AppConfig } from '../config';
import logoCpay from '../img/footer/footerLogo.svg';
import logoPayblock from '../img/footer/payblock-logo.png';
import logoNfg from '../img/nfgpay-svg/nfg_logo_black.svg';
import logoFinvaro from '../img/finvaro/finvaro-logo-black.png';
import logoClarnium from '../img/clarnium/clarnium-logo-color.png';
import logoInex from '../img/inex/inex-logo.svg';
import logoInsta from '../img/instaXchange/instaXchange-logo.png';
import logoCoinera from '../img/coinera/coinera-logo.png';
import { ReactComponent as HelpCircleSVG } from '../img/default-svg/help-circle-current.svg';
import TransakOpen from '../utils/transakSDK';
import { identity } from '../utils/getIdentity';
import TransactionNotification from '../components/TransactionNotification';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Switch, Tooltip } from 'antd';
import { getMerchantBalances } from '../redux/actions/merchantData';

const logos = {
  cpay: !AppConfig?.hideLogo ? logoCpay : logoPayblock,
  nfg: logoNfg,
  finvaro: logoFinvaro,
  clarnium: logoClarnium,
  inex: logoInex,
  insta: logoInsta,
  coinera: logoCoinera,
};

function Header({ toggleCollapseSider, siderState, merchantData, merchantId, typeNetwork, getMerchantBalances }) {
  const { currentWidth, isLg } = useWindowSize();
  const { t } = useTranslation();
  const [walletVersion, setWalletVersion] = useState(undefined);
  const initializedForMerchant = useRef(null);
  const walletVersionRef = useRef(walletVersion);
  walletVersionRef.current = walletVersion;

  useEffect(() => {
    const handleWalletVersionChange = () => {
      const wv = localStorage.getItem('walletVersion');
      if (wv && wv !== walletVersionRef.current) {
        setWalletVersion(wv);
      }
    };
    window.addEventListener('walletVersionChange', handleWalletVersionChange);
    return () => window.removeEventListener('walletVersionChange', handleWalletVersionChange);
  }, []);

  useEffect(() => {
    if (merchantData?.settingWallet?.version) {
      const version = merchantData.settingWallet.version;
      if (initializedForMerchant.current !== merchantId) {
        const wv = localStorage.getItem('walletVersion');
        if (wv) {
          setWalletVersion(wv);
        } else {
          setWalletVersion(version);
        }
        initializedForMerchant.current = merchantId;
      }
    }
    // merchantId intentionally omitted — we only reset when actual merchant data arrives
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData]);

  useEffect(() => {
    if (walletVersion) {
      const next = walletVersion;
      const prev = localStorage.getItem('walletVersion');

      localStorage.setItem('walletVersion', next);
      console.log('Setting walletVersion in localStorage.setItem, walletVersion:', next);
      if (prev !== next) {
        console.log('getMerchantBalances called from Header.jsx walletVersion effect, merchantId:', merchantId, 'typeNetwork:', typeNetwork, 'walletVersion:', next);
        if(merchantId) {
          getMerchantBalances(merchantId, typeNetwork, true, false, next);
        }
        window.dispatchEvent(new CustomEvent('walletVersionChange'));
      }
    }
  }, [walletVersion,merchantId]);

  return (
    <div className={`header header-${identity}`}>
      <div className="header__left">
        {currentWidth < 1360 && <Hamburger handler={toggleCollapseSider} opened={siderState} />}
        {isLg && (
          <Link to="/">
            <img
              className={`header__left--${identity} header__left-${AppConfig?.hideLogo}`}
              src={logos[AppConfig.identity]}
              alt="logo"
            />
          </Link>
        )}
        {process.env.REACT_APP_IS_AVAILABLE_NEW_WALLET === 'true' &&
          merchantData?.settingWallet?.version === 'v2' &&
          merchantData?.settingWallet?.defaultSetup === 'v1' && (
            <div className="header__version">
              <button 
                className={walletVersion === 'v2' ? 'header__version-btn active' : 'header__version-btn'} 
                onClick={() => setWalletVersion('v2')}
              >
                {t('admin.unifiedWallets')}
                <Tooltip
                  placement="bottomRight"
                  overlayClassName="header__version-tooltip"
                  title={<span>
                    <strong>{t('admin.unifiedWalletsTooltipTitle')}</strong><br />
                    {t('admin.unifiedWalletsTooltipText')}
                  </span>}
                >
                  <HelpCircleSVG />
                </Tooltip>
              </button>
              <button 
                className={walletVersion === 'v1' ? 'header__version-btn active' : 'header__version-btn'} 
                onClick={() => setWalletVersion('v1')}
              >
                {t('admin.legacyWallets')}
              </button>
            </div>
          )}
      </div>
      <div className="header__right">
        {/*{identity !== 'finvaro' && identity !== 'clarnium' && identity !== 'inex' && (
          <button
            className={`header__transak-button header__transak-button-${identity}`}
            onClick={TransakOpen}
            type="button"
          >
            Buy/Sell Crypto
          </button>
        )}*/}
        <div className="header__controls-wrapper header__merchant-selector-wrapper">
          {currentWidth >= 1024 ? <MerchantSelector /> : null}
        </div>
        {AppConfig?.showReleaseNotes && (
          <div className="header__controls-wrapper header__release-notes">
            <ReleaseNotes />
          </div>
        )}
        <div className="header__controls-wrapper header__controls-wrapper__notif">
          <TransactionNotification />
        </div>
        <div className="header__controls-wrapper">
          <HeaderUser />
        </div>
        {currentWidth <= 768 && !AppConfig?.hideLogo && (
          <Link to="/">
            <img
              className={
                (AppConfig.identity === 'clarnium' || AppConfig.identity === 'nfg' || AppConfig.identity === 'insta') &&
                'header__right-logo'
              }
              src={logos[AppConfig.identity]}
              alt="logo"
            />
          </Link>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  merchantId: state.transactions.merchantId,
  typeNetwork: state.networkFilter,
  merchantWallets: state.merchantWallets.data,
  page: state.merchantWallets.page,
  pages: state.merchantWallets.pages,
  currencies: state.currencies.data,
  merchants: state.merchants.data,
  autosignStatus: state.withdraw.autosignStatus,
  autosignStep: state.withdraw.autosignStep,
  merchantData: state.merchantData.data,
});
const mapDispatchToProps = dispatch => ({
  getMerchantBalances: getMerchantBalances(dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(Header);
